<template>
  <div>
    <div id="bilanco-rasyo" class="table-responsive">
      <table class="table is-fullwidth is-striped">
        <tr v-for="item in data" v-bind:key="item.id">
          <td v-for="it in item" v-bind:key="it.id">{{ it }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      data: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=BilancoRasyo?symbol=" +
          this.symbol +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(response => this.parseResponse(response));
  },
  methods: {
    parseResponse: function(response) {
      let data = iconv.decode(Buffer.from(response.data), "ISO-8859-9");
      let rows = data.split("\n");
      let say = 0;
      rows.forEach(row => {
         let tmpatrr = row.split(";");
         for(var j=0;j<tmpatrr.length;j++)
          {
           if(this.$i18n.locale == "en")
           {            
               if(tmpatrr[j].trim()=="") continue;
               if(tmpatrr[j]=="Tanım"){                       
                 tmpatrr[j]="Defination";
                 j=6;
               }
              if(tmpatrr[j]=="Cari Oran")tmpatrr[j]="Current rate";
              else if(tmpatrr[j]=="Likit Oran")tmpatrr[j]="Liquid Ratio";
              else if(tmpatrr[j]=="Nakit Oran")tmpatrr[j]="Cash Ratio";
              else if(tmpatrr[j]=="Kaldıraç Oranı")tmpatrr[j]="Leverage Ratio";
              else if(tmpatrr[j]=="Borçlar / Özsermaye")tmpatrr[j]="Liabilities / Equity";
              else if(tmpatrr[j]=="Maddi Duran Varlık / Özsermaye")tmpatrr[j]="Tangible Fixed Asset / Equity";
              else if(tmpatrr[j]=="K.Vade Borç / Toplam Borç")tmpatrr[j]="K. Term Debt / Total Debt";
              else if(tmpatrr[j]=="Alacak Devir Hızı")tmpatrr[j]="Receivable Turnover Rate";
              else if(tmpatrr[j]=="Alacak Tahsil Süresi")tmpatrr[j]="Receivable Collection Period";
              else if(tmpatrr[j]=="Stok Devir Hızı")tmpatrr[j]="Stock Turnover";
              else if(tmpatrr[j]=="Stokta Kalma Süresi")tmpatrr[j]="Out of Stock Time";
              else if(tmpatrr[j]=="Net İşletme Sermaye Devir Hızı")tmpatrr[j]="Net Working Capital Turnover";
              else if(tmpatrr[j]=="Özkaynak Devir Hızı")tmpatrr[j]="Equity Turnover Rate";
              else if(tmpatrr[j]=="Aktif Devir Hızı")tmpatrr[j]="Active RPM";
              else if(tmpatrr[j]=="Ticari Borç Devir Hızı")tmpatrr[j]="Commercial Debt Turnover";
              else if(tmpatrr[j]=="Ticari Borç Ödeme Süresi")tmpatrr[j]="Commercial Debt Payment Term";
              else if(tmpatrr[j]=="Brüt Kar Marjı (%)")tmpatrr[j]="Gross Margin (%)";
              else if(tmpatrr[j]=="Net Kar Marjı (%)")tmpatrr[j]="Net Profit Margin (%)";
              else if(tmpatrr[j]=="Faaliyet Kar Marjı (%)")tmpatrr[j]="Operating Profit Margin (%)";
              else if(tmpatrr[j]=="Aktif Karlılık Marjı (%)")tmpatrr[j]="Profitability Margin (%)";
              else if(tmpatrr[j]=="Özsermaye Karlılık Marjı (%)")tmpatrr[j]="Equity Profitability Margin (%)";
              else if(tmpatrr[j]=="Esas Faaliyet Kar Zararı")tmpatrr[j]="Main Operating Profit and Loss";
              else if(tmpatrr[j]=="Fin.Gid.Önc. Faaliyet Kar Zararı")tmpatrr[j]="Fin.Asc. Operating Profit Loss";
              else if(tmpatrr[j]=="Net Dönem Kar Zararı")tmpatrr[j]="Net Profit Loss for the Period";
              else if(tmpatrr[j]=="Net İşletme Sermayesi")tmpatrr[j]="Net Working Capital";
           }
         }

         for(var i=1;i<tmpatrr.length;i++)
         {
           if(tmpatrr[i].trim()=="") continue;         
             if(say==0)
             {
               let yil = tmpatrr[i].substr(0,2);
               let ceyrek = tmpatrr[i].substr(2,1);

               let donem = ""; 
               if(this.$i18n.locale=="en")donem = "20"+yil+"Q"+ceyrek;
               else donem="20"+yil+"Ç"+ceyrek;

               tmpatrr[i] = donem;
             }
         }
        this.data.push(tmpatrr);
        say =say+1;
      });
    }
  }
};
</script>

<style scoped>
/* #bilanco-rasyo {
  height: 400px;
  overflow: scroll;
} */
</style>